import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { changeStep } from "../store/settings/settingsSlice";
import { updateRegistrant } from "../store/registrant/registrantSlice";
import BackButton from "../Components/BackButton";
import AssistanceInformationForm from "../Forms/AssistanceInformationForm";
import { getContent } from "../content";

function AssistanceInformation() {
    let navigate = useNavigate();
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(changeStep([5, 6]));
    }, []);

    const onSubmit = (data) => {
        Object.keys(data).forEach(key => data[key] === undefined ? delete data[key] : {});

        dispatch(updateRegistrant({
            ...data
        }));

        navigate('/assistance-signature');
    };

    return (
        <section className="flex flex-col gap-4">
            <div className="">
                <BackButton onClick={() => navigate(-1)} />
                <h2 className="my-4 md:mt-8 lg:my-16">{getContent('assistance_information.heading')}</h2>
                <p>{getContent('assistance_information.content')}</p>
            </div>
            <div className="">
                <div className="border-4 border-evcpa-darkpurple rounded-lg p-8">
                    <AssistanceInformationForm submit={onSubmit} />
                </div>
            </div>
        </section>
    );
}

export default AssistanceInformation;